module.exports = __webpack_public_path__ + "img/mobilepainpoint2.ab2742d8.png";